module.exports = __webpack_public_path__ + "img/15.fdbdae20.jpg";